"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var IconMappings_exports = {};
__export(IconMappings_exports, {
  IconMappings: () => IconMappings
});
module.exports = __toCommonJS(IconMappings_exports);
const IconMappings = {
  "abacus": "e9fe",
  "accessibility": "e900",
  "activate-user": "ea62",
  "add-down": "eaa2",
  "add-slide": "eaa5",
  "add-up": "eaa3",
  "add-user": "e9c2",
  "admin-user": "ea89",
  "adn": "e901",
  "alarm": "e905",
  "alarm-add": "e902",
  "alarm-off": "e903",
  "alarm-on": "e904",
  "analyze": "ea09",
  "annotator-circle": "ea17",
  "annotator-freeform": "ea18",
  "annotator-line": "ea19",
  "annotator-polygon": "ea1c",
  "annotator-rectangle": "ea1a",
  "annotator-size": "ea1d",
  "annotator-square": "ea1b",
  "annotator-stroke": "ea1e",
  "answer-key": "ea22",
  "apps": "e906",
  "archive": "ea64",
  "aria-label": "ea70",
  "arrow": "ea8e",
  "arrow-back": "e907",
  "arrow-down": "e908",
  "arrow-drop-down": "e909",
  "arrow-drop-left": "ea6c",
  "arrow-drop-right": "ea6d",
  "arrow-drop-up": "e90a",
  "arrow-front": "e90b",
  "arrow-up": "e90c",
  "assess": "ea0a",
  "assess-clipboard": "ea4c",
  "assessment": "e9d1",
  "assign": "ea96",
  "attach-file": "e90d",
  "attachment": "e90e",
  "audio": "e9d0",
  "audio-video": "ea0e",
  "auth-layout-1-active": "ea7a",
  "auth-layout-1-inactive": "ea7b",
  "auth-layout-2-active": "ea7c",
  "auth-layout-2-inactive": "ea7d",
  "auth-layout-I-active": "ea7e",
  "auth-layout-I-inactive": "ea7f",
  "auth-layout-T-active": "ea80",
  "auth-layout-T-inactive": "ea81",
  "automatic-size": "ea5c",
  "autorenew": "e90f",
  "backpack": "e910",
  "bar-move-left": "ea1f",
  "bar-move-right": "ea20",
  "bell-f": "e911",
  "bell-o": "e912",
  "block": "e913",
  "book": "e915",
  "book-mark": "e914",
  "book-outline": "e9b5",
  "book-stacked": "e9ff",
  "bookmark-fill": "e916",
  "bookmark-outline": "e917",
  "border-all": "e918",
  "border-bottom": "e919",
  "border-clear": "e91a",
  "border-horizontal": "e91b",
  "border-inner": "e91c",
  "border-left": "e91d",
  "border-outer": "e91e",
  "border-right": "e91f",
  "border-top": "e920",
  "border-vertical": "e921",
  "bulk-images": "e9fd",
  "button": "e9b8",
  "button-group": "ea15",
  "calculator": "e922",
  "calendar": "e923",
  "call": "e924",
  "camera": "ea59",
  "categories": "ea2a",
  "categories-down": "ea28",
  "categories-left": "ea29",
  "check": "e925",
  "check-round": "e9cd",
  "checkbox-active": "e926",
  "checkbox-indeterminate": "e927",
  "checkbox-normal": "e928",
  "chevron-back": "e929",
  "chevron-down": "e92a",
  "chevron-front": "e92b",
  "chevron-up": "e92c",
  "ckeditor-fill": "ea69",
  "ckeditor-outline": "ea6a",
  "class-multipletools": "ea5f",
  "classes": "e92d",
  "classwork": "ea2b",
  "clear-all": "e9d2",
  "clock": "e92f",
  "clock-fill": "e92e",
  "close-round": "e930",
  "cloud-off": "e931",
  "code": "e932",
  "coding-layer": "e9b9",
  "collage": "ea99",
  "column-delete": "e9d3",
  "column-left": "e9d4",
  "column-right": "e9d8",
  "column-select": "e9d9",
  "comment": "e937",
  "comment-bubble": "e933",
  "comment-fill": "e934",
  "comment-inline": "e935",
  "comment-outline": "e936",
  "common-assessments": "ea0d",
  "common-diagnostic": "e9f1",
  "compare-arrows": "e938",
  "compass": "e939",
  "content-copy": "e93a",
  "content-cut": "e93b",
  "content-paste": "e93c",
  "cross-check": "e9c4",
  "cuadruple-line": "ea43",
  "dashboard": "e93d",
  "delete-fill": "e93e",
  "delete-outline": "e93f",
  "diagnostic": "e9d5",
  "diamond": "e9c7",
  "digital_classwork": "ea4e",
  "disable-user": "ea61",
  "distance": "e940",
  "doc": "e9cf",
  "doc-csv": "e9dd",
  "doc-pdf": "e9df",
  "doc-ppt": "e9e0",
  "doc-xls": "e9e1",
  "done-all": "e941",
  "dot": "e942",
  "dot-stroke": "ea23",
  "double-back": "ea00",
  "double-check": "e9c5",
  "double-cross": "e9c6",
  "double-down": "ea01",
  "double-front": "ea02",
  "double-line": "ea44",
  "double-up": "ea03",
  "download": "e943",
  "drafts": "e944",
  "drag-and-drop": "ea65",
  "drag-drop": "e945",
  "draw": "ea97",
  "dropdown": "ea9a",
  "duplicate": "e946",
  "ebook": "e9d6",
  "equation": "e9b6",
  "essay": "e9d7",
  "event-available": "e947",
  "event-busy": "e948",
  "event-note": "e949",
  "exchange": "e94a",
  "expand": "e9fc",
  "eye": "e94c",
  "eye-off": "e94b",
  "family": "e9ed",
  "favorite-fill": "e94d",
  "favorite-outline": "e94e",
  "fill-the-blank": "ea2c",
  "filter": "e94f",
  "first-page": "e950",
  "flag": "e951",
  "flag-outline": "ea04",
  "folder": "e953",
  "folder-open": "e952",
  "format-align-center": "e954",
  "format-align-justify": "e955",
  "format-align-left": "e956",
  "format-align-right": "e957",
  "format-bold": "e958",
  "format-clear": "e959",
  "format-color-text": "e95a",
  "format-italic": "e95b",
  "format-line-spacing": "e95c",
  "format-list-bulleted": "e95d",
  "format-list-numbered": "e95e",
  "format-quote": "e95f",
  "format-size": "e960",
  "format-strikethrough": "e961",
  "format-underlined": "e962",
  "fullscreen": "e964",
  "fullscreen-exit": "e963",
  "functions": "e965",
  "g-translate": "e966",
  "geodes-preview": "ea66",
  "go-to": "e9bb",
  "go-to-fill": "e9ba",
  "graph": "e9bc",
  "guide": "ea78",
  "habitat-circle": "ea3d",
  "habitat-fit": "ea45",
  "habitat-freeform": "ea3e",
  "habitat-line": "ea3f",
  "habitat-minus": "ea46",
  "habitat-plus": "ea47",
  "habitat-rectangle": "ea40",
  "habitat-redo": "ea48",
  "habitat-square": "ea41",
  "habitat-triangle": "ea42",
  "habitat-undo": "ea49",
  "hamburguer": "e967",
  "help": "e968",
  "highlight": "ea0f",
  "hint": "ea16",
  "home": "e969",
  "image-fill": "e96a",
  "image-gallery": "ea10",
  "image-missing": "ea11",
  "image-outline": "e96b",
  "impersonate": "ea36",
  "inbox": "e96c",
  "info": "e96d",
  "information-plain": "ea67",
  "input": "e9bd",
  "insert-link": "e96e",
  "insert-link-vertical": "ea83",
  "inverted-triangle": "e9cc",
  "journal": "e9e2",
  "key": "ea05",
  "keyboard": "ea5a",
  "keyboard-voice": "e96f",
  "lap-asynchro": "e9f3",
  "lap-class-synchro": "ea07",
  "lap-computer": "e9f4",
  "lap-discuss": "e9f5",
  "lap-exploration": "e9ef",
  "lap-modeling": "e9f0",
  "lap-pencil": "e9f6",
  "lap-problem": "ea0c",
  "lap-socratic": "e9f2",
  "lap-synchro": "e9f7",
  "last-page": "e970",
  "lesson-board": "e971",
  "library": "e972",
  "license": "ea37",
  "license-administration": "ea8d",
  "license-manager": "ea8c",
  "light-bulb": "ea06",
  "link": "e973",
  "loading-circle": "e974",
  "loading-dots": "e975",
  "location": "e976",
  "locked": "e9e3",
  "log-out": "ea25",
  "mail-fill": "e977",
  "mail-outline": "e978",
  "manage": "ea38",
  "map": "e979",
  "mark-cell": "ea5d",
  "mark-header": "ea5e",
  "math": "e97a",
  "math-indicator": "e9ec",
  "math-manip": "e9e4",
  "math-off": "e9e5",
  "math-on": "e9e6",
  "math-placeholder": "ea2d",
  "megaphone-fill": "e9f8",
  "megaphone-outline": "e9f9",
  "merge": "ea57",
  "message": "e97b",
  "mic-fill": "e97c",
  "mic-off": "e97d",
  "mic-outline": "e97e",
  "minus": "e97f",
  "missing-file": "ea51",
  "mix-off": "ea2e",
  "mix-on": "ea2f",
  "mix-placeholder": "ea30",
  "molecule": "e980",
  "more-hor": "e981",
  "more-underline": "ea6f",
  "more-ver": "e982",
  "move": "e9be",
  "navigation": "e983",
  "no-clones": "ea60",
  "not-synced": "ea9e",
  "note": "ea9f",
  "object-delete": "eaa0",
  "open-tab": "ea21",
  "oval": "e9c8",
  "party": "e984",
  "pause": "e985",
  "pencil": "e986",
  "percentage": "ea73",
  "play": "e988",
  "play-fill": "e987",
  "plug": "ea71",
  "plus": "e98a",
  "plus-circle": "e989",
  "polygon": "ea27",
  "practice": "e9da",
  "preview-card": "e9fb",
  "print": "e9de",
  "prize": "e98b",
  "prologue": "ea79",
  "prologue_active": "ea9b",
  "promote": "ea84",
  "publish": "ea82",
  "published": "e98c",
  "question-answer": "e98d",
  "radio-active": "e98e",
  "radio-normal": "e98f",
  "redirect-link": "ea75",
  "redo": "e990",
  "refresh": "e991",
  "remove": "ea63",
  "reports": "e992",
  "reports-graph": "e9b7",
  "resize-handler": "e9fa",
  "review-clipboard": "e993",
  "review-lesson": "e994",
  "rocket": "e995",
  "round": "ea98",
  "round-check": "e9db",
  "round-cross": "e9dc",
  "round-square": "e9c9",
  "row-above": "e9e7",
  "row-below": "e9e8",
  "row-delete": "e9e9",
  "row-select": "e9ea",
  "save": "e996",
  "school": "ea39",
  "school-disabled": "ea74",
  "school-settings": "ea8a",
  "search": "e997",
  "sections": "ea3a",
  "select": "ea24",
  "send": "e998",
  "settings": "e99a",
  "settings-fill": "e999",
  "share": "e99b",
  "share-group": "e9c3",
  "share-link": "ea68",
  "share-simple": "ea72",
  "shortcut": "ea93",
  "single-line": "ea4a",
  "site-code": "ea5b",
  "skip": "e99c",
  "split": "ea58",
  "square": "e9ca",
  "staff": "ea3b",
  "star-fill": "e99d",
  "star-half": "e99e",
  "star-outline": "e99f",
  "start-drag": "ea31",
  "status-complete": "ea8f",
  "status-in-progress": "ea90",
  "status-not-complete": "ea91",
  "stop": "e9a0",
  "stop-drag": "ea32",
  "student-desk": "ea6e",
  "student-tracker": "ea6b",
  "students": "ea3c",
  "study": "ea0b",
  "subdirectory-arrow-left": "e9a1",
  "subdirectory-arrow-right": "e9a2",
  "success-synced": "eaa1",
  "sync-manage": "ea8b",
  "synced": "ea76",
  "table-complex": "ea50",
  "target": "ea94",
  "teach": "ea4d",
  "teacher": "ea08",
  "text-box": "e9bf",
  "timeline": "e9a3",
  "title-text": "e9a4",
  "toggle-tool": "e9ce",
  "tool": "ea88",
  "touch-screen": "e9a5",
  "transform": "ea9c",
  "translate": "e9a6",
  "triangle": "e9cb",
  "triple-line": "ea4b",
  "type-off": "ea33",
  "type-on": "ea34",
  "type-placeholder": "ea35",
  "unarchive": "e9a7",
  "unassigned": "e9c0",
  "unattempted": "ea92",
  "unattempted-round": "ea95",
  "undo": "e9a8",
  "unfold-less": "e9a9",
  "unfold-more": "e9aa",
  "unlink": "ea85",
  "unlocked": "e9eb",
  "unpublish": "ea86",
  "up-down": "ea77",
  "upload": "e9ab",
  "user": "e9ac",
  "video": "ea26",
  "view-big": "ea12",
  "view-carousel": "e9ad",
  "view-compact": "e9ae",
  "view-four-col": "ea9d",
  "view-grid": "e9af",
  "view-list": "e9b0",
  "view-medium": "ea13",
  "view-one-col": "ea52",
  "view-small": "ea14",
  "view-three-col": "ea53",
  "view-two-col": "ea54",
  "vip": "eaa4",
  "voice-teacher": "ea87",
  "warning": "e9b2",
  "warning-fill": "e9b1",
  "whats-next": "ea4f",
  "wit-pencil": "e9c1",
  "world": "e9b3",
  "world-outline": "e9ee",
  "x": "e9b4",
  "zoom-in": "ea55",
  "zoom-out": "ea56"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  IconMappings
});
